import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';

import { RankingMethodologySection } from './theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import { ThemeExposureTable } from './theme-exposure-table/ThemeExposureTable';
import styles from './ThemeExposureTab.module.scss';

export interface ThemeExposureTabProps {
  entity: Entity;
}

export const ThemeExposureTab = ({ entity }: ThemeExposureTabProps) => {
  return (
    <div className={styles.root} data-testid="theme-exposure-tab">
      <ErrorBoundaryWrapper
        fallback={
          <>
            <ErrorMessageWrapper
              className={styles.styledErrorMessageWrapper}
              displayIcon
            />
            <RankingMethodologySection rankingType={'companyToTheme'} />
          </>
        }
      >
        <ThemeExposureTable entity={entity} />
      </ErrorBoundaryWrapper>
    </div>
  );
};
